export interface CategoryTag {
  label: string;
  background: string;
  color: string;
}

// Known Odoo root categories get short labels and distinct hues; anything new or
// renamed in Odoo falls through to a neutral chip with the raw root name.
const KNOWN_TAGS: Record<string, CategoryTag> = {
  'Consumables (Non Storable)': { label: 'Consumables', background: '#FEF3C7', color: '#92400E' },
  Tools: { label: 'Tools', background: '#EDE9FE', color: '#5B21B6' },
  'Raw Materials': { label: 'Raw Materials', background: '#DBEAFE', color: '#1E40AF' },
  'Fixed Assets': { label: 'Fixed Assets', background: '#E2E8F0', color: '#334155' },
  'Sub-Assembly': { label: 'Sub-Assembly', background: '#CCFBF1', color: '#115E59' },
};

const FALLBACK_BACKGROUND = '#F1F5F9';
const FALLBACK_COLOR = '#475569';

export function categoryTagFor(productCategory: string): CategoryTag {
  return KNOWN_TAGS[productCategory] ?? { label: productCategory, background: FALLBACK_BACKGROUND, color: FALLBACK_COLOR };
}
